import { LOGOUT, SET_DRIVERS, SET_OPEN_ORDERS, SET_ORDERS_IN_PROGRESS } from "../actionTypes";

export const LOGISTICS_ACTION_TYPES = {
	POST_ASSIGN_DRIVER: 'POST_ASSIGN_DRIVER',
	POST_ASSIGN_DRIVER_DONE: 'POST_ASSIGN_DRIVER_DONE',
	GET_ORDERS_IN_PROGRESS: "GET_ORDERS_IN_PROGRESS",
	GET_ORDERS_IN_PROGRESS_DONE: "GET_ORDERS_IN_PROGRESS_DONE",
	GET_ORDERS_IN_PROGRESS_ERROR: "GET_ORDERS_IN_PROGRESS_ERROR",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR",
	GET_OPEN_ORDERS: "GET_OPEN_ORDERS",
	GET_OPEN_ORDERS_DONE: "GET_OPEN_ORDERS_DONE",
	GET_OPEN_ORDERS_ERROR: "GET_OPEN_ORDERS_ERROR",
	GET_OPEN_ORDERS_ON_PAGE_CHANGE: "GET_OPEN_ORDERS_ON_PAGE_CHANGE",
	GET_OPEN_ORDERS_ON_PAGE_CHANGE_DONE: "GET_OPEN_ORDERS_ON_PAGE_CHANGE_DONE",
	GET_OPEN_ORDERS_ON_PAGE_CHANGE_ERROR: "GET_OPEN_ORDERS_ON_PAGE_CHANGE_ERROR",
	GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE: "GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE",
	GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: "GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE",
	GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: "GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR",
	GET_OPEN_ORDERS_FOR_SEARCHED_QUERY: "GET_OPEN_ORDERS_FOR_SEARCHED_QUERY",
	GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_DONE: "GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_DONE",
	GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_ERROR: "GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_ERROR",
	GET_PREVIOUS_ORDERS: "GET_PREVIOUS_ORDERS",
	GET_PREVIOUS_ORDERS_DONE: "GET_PREVIOUS_ORDERS_DONE",
	GET_PREVIOUS_ORDERS_ERROR: "GET_PREVIOUS_ORDERS_ERROR",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR",
	PUT_CANCEL_ASSIGNED_DRIVER: "PUT_CANCEL_ASSIGNED_DRIVER",
	PUT_CANCEL_ASSIGNED_DRIVER_DONE: "PUT_CANCEL_ASSIGNED_DRIVER_DONE",
	PUT_CANCEL_ASSIGNED_DRIVER_ERROR: "PUT_CANCEL_ASSIGNED_DRIVER_ERROR",
};

export const setOpenOrders = (payload) => {
	return {
		type: SET_OPEN_ORDERS,
		payload,
	};
};

export const setOrdersInProgress = (payload) => {
	return {
		type: SET_ORDERS_IN_PROGRESS,
		payload,
	};
};

export const setDrivers = (payload) => {
	return {
		type: SET_DRIVERS,
		payload,
	};
};


export const resetLogisticState = (payload) => {
	return {
		type: LOGOUT,
		payload,
	};
};

export const assignDriver = payload => {
	return {
		type: LOGISTICS_ACTION_TYPES.POST_ASSIGN_DRIVER,
		payload,
	}
}


export const getLogisticsOrdersInProgressAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS,
	payload: req,
});

export const getLogisticsOrdersInProgressDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_DONE,
	payload: req,
});

export const getLogisticsOrdersInProgressErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ERROR,
	payload: req,
});

export const getLogisticsOrdersInProgressOnPageChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE,
	payload: req,
});

export const getLogisticsOrdersInProgressOnPageChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE,
	payload: req,
});

export const getLogisticsOrdersInProgressOnPageChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR,
	payload: req,
});

export const getLogisticsOrdersInProgressPerPageLimitChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE,
	payload: req,
});

export const getLogisticsOrdersInProgressPerPageLimitChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE,
	payload: req
});

export const getLogisticsOrdersInProgressPerPageLimitChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR,
	payload: req
});

export const getLogisticsOrdersInProgressForSearchedQueryAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY,
	payload: req,
});

export const getLogisticsOrdersInProgressForSearchedQueryDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE,
	payload: req,
});

export const getLogisticsOrdersInProgressForSearchedQueryErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR,
	payload: req,
});

export const getLogisticsOpenOrdersAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS,
	payload: req
});

export const getLogisticsOpenOrdersDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_DONE,
	payload: req
});

export const getLogisticsOpenOrdersErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ERROR,
	payload: req
});

export const getLogisticsOpenOrdersOnPageChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE,
	payload: req
});

export const getLogisticsOpenOrdersOnPageChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE_DONE,
	payload: req
});

export const getLogisticsOpenOrdersOnPageChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE_ERROR,
	payload: req
});

export const getLogisticsOpenOrdersPerPageLimitChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE,
	payload: req
});

export const getLogisticsOpenOrdersPerPageLimitChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE,
	payload: req
});

export const getLogisticsOpenOrdersPerPageLimitChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR,
	payload: req
});

export const getLogisticsOpenOrdersForSearchedQueryAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_FOR_SEARCHED_QUERY,
	payload: req
});

export const getLogisticsOpenOrdersForSearchedQueryDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_DONE,
	payload: req
});

export const getLogisticsOpenOrdersForSearchedQueryErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_ERROR,
	payload: req
});

export const getLogisticsPreviousOrdersAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS,
	payload: req
});

export const getLogisticsPreviousOrdersDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_DONE,
	payload: req
});

export const getLogisticsPreviousOrdersErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ERROR,
	payload: req
});

export const getLogisticsPreviousOrdersOnPageChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE,
	payload: req
});

export const getLogisticsPreviousOrdersOnPageChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE,
	payload: req
});

export const getLogisticsPreviousOrdersOnPageChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR,
	payload: req
});

export const getLogisticsPreviousOrdersPerPageLimitChangeAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE,
	payload: req
});

export const getLogisticsPreviousOrdersPerPageLimitChangeDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE,
	payload: req
});

export const getLogisticsPreviousOrdersPerPageLimitChangeErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR,
	payload: req
});

export const getLogisticsPreviousOrdersForSearchedQueryAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY,
	payload: req
});

export const getLogisticsPreviousOrdersForSearchedQueryDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE,
	payload: req
});

export const getLogisticsPreviousOrdersForSearchedQueryErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR,
	payload: req
});


export const putCancelAssignedDriverAction = req => ({
	type: LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER,
	payload: req
});

export const putCancelAssignedDriverDoneAction = req => ({
	type: LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER_DONE,
	payload: req
});

export const putCancelAssignedDriverErrorAction = req => ({
	type: LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER_ERROR,
	payload: req
});



export default {
	LOGISTICS_ACTION_TYPES,
	setOpenOrders,
	setOrdersInProgress,
	setDrivers,
	resetLogisticState,
	assignDriver,
	getLogisticsOrdersInProgressAction,
	getLogisticsOrdersInProgressDoneAction,
	getLogisticsOrdersInProgressErrorAction,
	getLogisticsOrdersInProgressOnPageChangeAction,
	getLogisticsOrdersInProgressOnPageChangeDoneAction,
	getLogisticsOrdersInProgressOnPageChangeErrorAction,
	getLogisticsOrdersInProgressPerPageLimitChangeAction,
	getLogisticsOrdersInProgressPerPageLimitChangeDoneAction,
	getLogisticsOrdersInProgressPerPageLimitChangeErrorAction,
	getLogisticsOrdersInProgressForSearchedQueryAction,
	getLogisticsOrdersInProgressForSearchedQueryDoneAction,
	getLogisticsOrdersInProgressForSearchedQueryErrorAction,
	getLogisticsOpenOrdersAction,
	getLogisticsOpenOrdersDoneAction,
	getLogisticsOpenOrdersErrorAction,
	getLogisticsOpenOrdersOnPageChangeAction,
	getLogisticsOpenOrdersOnPageChangeDoneAction,
	getLogisticsOpenOrdersOnPageChangeErrorAction,
	getLogisticsOpenOrdersPerPageLimitChangeAction,
	getLogisticsOpenOrdersPerPageLimitChangeDoneAction,
	getLogisticsOpenOrdersPerPageLimitChangeErrorAction,
	getLogisticsOpenOrdersForSearchedQueryAction,
	getLogisticsOpenOrdersForSearchedQueryDoneAction,
	getLogisticsOpenOrdersForSearchedQueryErrorAction,
	getLogisticsPreviousOrdersAction,
	getLogisticsPreviousOrdersDoneAction,
	getLogisticsPreviousOrdersErrorAction,
	getLogisticsPreviousOrdersOnPageChangeAction,
	getLogisticsPreviousOrdersOnPageChangeDoneAction,
	getLogisticsPreviousOrdersOnPageChangeErrorAction,
	getLogisticsPreviousOrdersPerPageLimitChangeAction,
	getLogisticsPreviousOrdersPerPageLimitChangeDoneAction,
	getLogisticsPreviousOrdersPerPageLimitChangeErrorAction,
	getLogisticsPreviousOrdersForSearchedQueryAction,
	getLogisticsPreviousOrdersForSearchedQueryDoneAction,
	getLogisticsPreviousOrdersForSearchedQueryErrorAction,
	putCancelAssignedDriverAction,
	putCancelAssignedDriverDoneAction,
	putCancelAssignedDriverErrorAction,
}